import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SharedService } from '@myproject/shared/shared.service';
import { GraphicReportsService } from '../../graphic-reports.service';
import { Chart, registerables } from 'chart.js';
import { DatePipe } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { environment } from '@myenv/environment';
import * as FileSaver from 'file-saver';

@Component({
    selector: 'app-provision-billing',
    templateUrl: './provision-billing.component.html',
    styleUrls: ['./provision-billing.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProvisionBillingComponent implements OnInit {

  isLoading = false;
  // totalCounts = {
  //   total: 0,
  //   sTrigger: 0,
  //   cTrigger: 0,
  //   cCumulative: 0
  // };
  // totalPrices = {
  //   total: 0,
  //   sTrigger: 0,
  //   cTrigger: 0,
  //   cCumulative: 0
  // };
  display_prices = {
    total: '0',
    sTrigger: '0',
    cTrigger: '0',
    cCumulative: '0'
  };
  display_counts = {
    total: '0',
    sTrigger: '0',
    cTrigger: '0',
    cCumulative: '0'
  };
  oneMonthData: any = null;
  doughnutChart: any;
  barChart: any;
  horizontalBarChart: any;
  lineChart: any;
  selectedMonth = {
    text: '1 Month',
    month: 1
  };

  constructor(
    private title: Title,
    private reportsService: GraphicReportsService,
    private sharedService: SharedService
  ) { }

  ngOnInit() {
    Chart.register(...registerables);
    this.title.setTitle('Billing' + environment.title_text);
    this.onMonthsChange(6);
  }

  refresh() {
    this.oneMonthData = null;
    // this.totalCounts = { total: 0, sTrigger: 0, cTrigger: 0, cCumulative: 0 };
    // this.totalPrices = { total: 0, sTrigger: 0, cTrigger: 0, cCumulative: 0 };
    this.display_prices = { total: '0', sTrigger: '0', cTrigger: '0', cCumulative: '0' };
    this.display_counts = { total: '0', sTrigger: '0', cTrigger: '0', cCumulative: '0' };
    this.getProvisionBillingData(this.selectedMonth.month);
  }

  onMonthsChange(months) {
    this.isLoading = true;
    if (months === 1) {
      this.selectedMonth = {
        text: '1 Month',
        month: 1
      };
    } else if (months === 3) {
      this.selectedMonth = {
        text: '3 Months',
        month: 3
      };
    } else if (months === 6) {
      this.selectedMonth = {
        text: '6 Months',
        month: 6
      };
    } else if (months === 12) {
      this.selectedMonth = {
        text: '12 Months',
        month: 12
      };
    }
    this.getProvisionBillingData(months);
  }

  getProvisionBillingData(months) {
    this.reportsService.getProvisionBillingData(months).subscribe({
      next: res => {
        // this.totalCounts = { total: 0, sTrigger: 0, cTrigger: 0, cCumulative: 0 };
        // this.totalPrices = { total: 0, sTrigger: 0, cTrigger: 0, cCumulative: 0 };
        // this.display_totalPrices = { total: '0', sTrigger: '0', cTrigger: '0', cCumulative: '0' };
        if (res.length) {
          if (!this.oneMonthData) {
            this.sort1MonthData(res[0]);
          }
          this.sortData(res);
        }
        this.isLoading = false;
      },
      error: error => {
        this.isLoading = false;
        this.sharedService.getErrorMsg(error);
      }
    });
  }

  sort1MonthData(resObj) {
    const labels = ['S Triggers', 'C Triggers', 'C Triggers Cumulative'];
    const counts = [];
    const prices = [];
    // push counts in labels order
    counts.push(resObj.sTriggerCount);
    counts.push(resObj.cTriggerCount);
    counts.push(resObj.cCumulativeCount);
    // push prices in labels order
    prices.push(resObj.sTriggerPrice);
    prices.push(resObj.cTriggerPrice);
    prices.push(resObj.cCumulativePrice);
    // for price display
    const total = resObj.sTriggerPrice + resObj.cTriggerPrice + resObj.cCumulativePrice;
    this.display_prices.total = this.numDifferentiation(total);
    this.display_prices.sTrigger = this.numDifferentiation(resObj.sTriggerPrice);
    this.display_prices.cTrigger = this.numDifferentiation(resObj.cTriggerPrice);
    this.display_prices.cCumulative = this.numDifferentiation(resObj.cCumulativePrice);
    // for counts display
    this.display_counts.sTrigger = this.addCommas(resObj.sTriggerCount);
    this.display_counts.cTrigger = this.addCommas(resObj.cTriggerCount);
    this.display_counts.cCumulative = this.addCommas(resObj.cCumulativeCount);
    // bill date
    const datePipe = new DatePipe('en-US');
    resObj.endDate = datePipe.transform(resObj.billDate, 'dd MMM, yyyy');
    const d = new Date(resObj.billDate);
    d.setDate(d.getDate() - 30);
    resObj.startDate = datePipe.transform(d, 'dd MMM, yyyy');
    // assign obj to global variable
    this.oneMonthData = JSON.parse(JSON.stringify(resObj));
    // draw graphs
    this.drawDoughnutChart(labels, counts, prices);
    this.drawHorizontalBarChart(labels, counts, prices);
  }

  sortData(res) {
    // const doughnut_labels = ['S Trigger', 'C Trigger', 'C Cumulative'];
    // const doughnut_counts = [];
    // const doughnut_prices = [];
    const date_labels = [];
    const bar_counts = {
      sTrigger: [],
      cTrigger: [],
      cCumulative: []
    };
    const line_prices = {
      sTrigger: [],
      cTrigger: [],
      cCumulative: []
    };
    res.reverse();
    res.map(item => {
      // counts summation
      // this.totalCounts.sTrigger += item.sTriggerCount;
      // this.totalCounts.cTrigger += item.cTriggerCount;
      // this.totalCounts.cCumulative += item.cCumulativeCount;
      // price summation
      // this.totalPrices.sTrigger += item.sTriggerPrice;
      // this.totalPrices.cTrigger += item.cTriggerPrice;
      // this.totalPrices.cCumulative += item.cCumulativePrice;
      // data sorting for chart
      const datePipe = new DatePipe('en-US');
      const eventDate = datePipe.transform(item.billDate, 'MMM, yyyy');
      date_labels.push(eventDate);
      // for vertical bar counts
      bar_counts.sTrigger.push(item.sTriggerCount);
      bar_counts.cTrigger.push(item.cTriggerCount);
      bar_counts.cCumulative.push(item.cCumulativeCount);
      // for line prices
      line_prices.sTrigger.push(item.sTriggerPrice);
      line_prices.cTrigger.push(item.cTriggerPrice);
      line_prices.cCumulative.push(item.cCumulativePrice);
    });
    // count push for doughnut chart
    // doughnut_counts.push(this.totalCounts.sTrigger);
    // doughnut_counts.push(this.totalCounts.cTrigger);
    // doughnut_counts.push(this.totalCounts.cCumulative);
    // doughnut_prices.push(this.totalPrices.sTrigger);
    // doughnut_prices.push(this.totalPrices.cTrigger);
    // doughnut_prices.push(this.totalPrices.cCumulative);
    // total
    // this.totalCounts.total = this.totalCounts.sTrigger + this.totalCounts.cTrigger + this.totalCounts.cCumulative;
    // this.totalPrices.total = this.totalPrices.sTrigger + this.totalPrices.cTrigger + this.totalPrices.cCumulative;
    // price display
    // this.display_totalPrices.total = this.numDifferentiation(this.totalPrices.total);
    // this.display_totalPrices.sTrigger = this.numDifferentiation(this.totalPrices.sTrigger);
    // this.display_totalPrices.cTrigger = this.numDifferentiation(this.totalPrices.cTrigger);
    // this.display_totalPrices.cCumulative = this.numDifferentiation(this.totalPrices.cCumulative);
    // draw Charts
    // this.drawDoughnutChart(doughnut_labels, doughnut_counts, doughnut_prices);
    this.drawBarChart(date_labels, bar_counts.sTrigger, bar_counts.cTrigger, bar_counts.cCumulative);
    this.drawLineChart(date_labels, line_prices.sTrigger, line_prices.cTrigger, line_prices.cCumulative);
  }

  drawDoughnutChart(labels, counts, prices) {
    if (this.doughnutChart) {
      this.doughnutChart.destroy();
    }
    var ctx = document.getElementById('doughnutChart') as HTMLCanvasElement;
    this.doughnutChart = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: labels,
        datasets: [{
          label: 'Price',
          data: prices,
          backgroundColor: [
            'rgb(124, 111, 241, 1)',
            'rgb(75, 154, 248, 1)',
            'rgb(0, 128, 128, 0.8)',
          ]
        }, {
          label: 'Count',
          data: counts,
          backgroundColor: [
            'rgb(124, 111, 241, 1)',
            'rgb(75, 154, 248, 1)',
            'rgb(0, 128, 128, 0.8)',
          ]
        }
        ]
      },
      options: {
        responsive: true,
        plugins: {
        legend: {
          position: 'right',
          display: false
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                const dataset = context.dataset;
                const index = context.dataIndex;
                const label = context.chart.data.labels[index];
                return `${dataset.label}: ${label}: ${dataset.data[index]}`;
              }
            }
          }
        },
        scales: {
          x: {
            display: false,
            beginAtZero: true
          },
          y: {
            display: false,
            beginAtZero: true
          }
        },
      }
    });
  }

  drawHorizontalBarChart(labels, counts, prices) {
    if (this.horizontalBarChart) {
      this.horizontalBarChart.destroy();
    }
    const data = {
      labels: labels,
      datasets: [
        {
          label: 'Devices',
          backgroundColor: 'rgb(0, 128, 128, 0.8)',
          data: counts
        },
        // {
        //   label: 'Price',
        //   backgroundColor: 'rgb(75, 154, 248, 1)',
        //   data: prices
        // }
      ]
    };
    var ctx = document.getElementById('horizontalBar') as HTMLCanvasElement;
    this.horizontalBarChart = new Chart(ctx, {
      type: 'bar',
      data: data,
      options: {
        indexAxis: 'y',
        responsive: true,
        plugins: {
        legend: {
          position: 'bottom',
          display: false
        },
        tooltip: {
          // Disable the on-canvas tooltip
          enabled: false,
          callbacks: {
            labelColor: (ctx) => ({
              borderColor: 'rgb(255, 0, 0)',
              backgroundColor: 'rgb(255, 0, 0)'
            }),
            labelTextColor: () => '#543453'
          },

          external: (ctx) => {
            const tooltipModel = ctx.tooltip;
            // Tooltip Element
            var tooltipEl: any = document.getElementById('chartjs-tooltip');

            // Create element on first render
            if (!tooltipEl) {
              tooltipEl = document.createElement('div');
              tooltipEl.id = 'chartjs-tooltip';
              tooltipEl.innerHTML = '<table></table>';
              document.body.appendChild(tooltipEl);
            }

            // Hide if no tooltip
            if (tooltipModel.opacity === 0) {
              tooltipEl.style.opacity = 0;
              return;
            }

            // Set caret Position
            tooltipEl.classList.remove('above', 'below', 'no-transform');
            if (tooltipModel.yAlign) {
              tooltipEl.classList.add(tooltipModel.yAlign);
            } else {
              tooltipEl.classList.add('no-transform');
            }

            function getBody(bodyItem) {
              return bodyItem.lines;
            }

            // Set Text
            if (tooltipModel.body) {
              var titleLines = tooltipModel.title || [];
              var bodyLines = tooltipModel.body.map(getBody);

              var innerHtml = '<thead>';

              titleLines.forEach(function (title) {
                innerHtml += '<tr><th>' + title + '</th></tr>';
              });
              innerHtml += '</thead><tbody>';

              bodyLines.forEach(function (body, i) {
                var colors = tooltipModel.labelColors[i];
                var style = 'background:' + colors.backgroundColor;
                style += '; border-color:' + colors.borderColor;
                style += '; border-width: 2px';
                var span = '<span style="' + style + '"></span>';
                innerHtml += '<tr><td>' + span + body + '</td></tr>';
              });
              innerHtml += '</tbody>';

              var tableRoot = tooltipEl.querySelector('table');
              tableRoot.innerHTML = innerHtml;
            }

            // `this` will be the overall tooltip
            var position = ctx.chart.canvas.getBoundingClientRect();

            // Display, position, and set styles for font
            tooltipEl.style.opacity = 1;
            tooltipEl.style.position = 'absolute';
            tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
            tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
            const font = (Chart as any).helpers.toFont(tooltipModel.options.bodyFont);
            tooltipEl.style.fontFamily = font.family;
            tooltipEl.style.fontSize = font.size + 'px';
            tooltipEl.style.fontStyle = font.style;
            const pad = (tooltipModel as any).padding ?? {x:0,y:0}
            tooltipEl.style.padding = pad.y + 'px ' + pad.x + 'px';
            tooltipEl.style.pointerEvents = 'none';
            tooltipEl.style.color = '#ffff';
            tooltipEl.style.backgroundColor = 'rgba(29, 28, 26, 0.8)';
            tooltipEl.style.borderRadius = '3px';
          }
        }
        },
        scales: {
          y: {
            beginAtZero: true,
            suggestedMin: 0,
            suggestedMax: 10,
            ticks: {
              maxTicksLimit: 10
            }
            // stepSize: highestCount > 9 ? null : 1
          },
          x: {
            display: false,
            ticks: {
              autoSkip: true,
              maxTicksLimit: 12
            }
          }
        },
      }
    });
  }

  drawBarChart(labels, sTrigger, cTrigger, cCumulative) {
    const global = this;
    if (this.barChart) {
      this.barChart.destroy();
    }
    const data = {
      labels: labels,
      datasets: [
        {
          label: 'S Triggers',
          backgroundColor: 'rgb(124, 111, 241, 1)',
          data: sTrigger
        },
        {
          label: 'C Triggers',
          backgroundColor: 'rgb(75, 154, 248, 1)',
          data: cTrigger
        },
        {
          label: 'C Triggers Cumulative',
          backgroundColor: 'rgb(0, 128, 128, 0.8)',
          data: cCumulative
        }
      ]
    };
    var ctx = document.getElementById('barChart') as HTMLCanvasElement;
    this.barChart = new Chart(ctx, {
      type: 'bar',
      data: data,
      options: {
        responsive: true,
        plugins: {
        legend: {
          position: 'bottom',
          display: true
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            suggestedMin: 0,
            suggestedMax: 10,
            ticks: {
              maxTicksLimit: 10
            }
            // stepSize: highestCount > 9 ? null : 1
          },
          x: {
            ticks: {
              autoSkip: true,
              maxTicksLimit: 12
            }
          }
        },
        onClick: (event, elements, chart) => {
          if (!elements.length) return;
          const index = elements[0].index;
          const label = chart.data.labels[index] as string;
          this.downloadMonthlyBill(label);
        }
      }
    });
  }

  drawLineChart(labels, sTrigger, cTrigger, cCumulative) {
    if (this.lineChart) {
      this.lineChart.destroy();
    }
    var ctx = document.getElementById('lineChart') as HTMLCanvasElement;
    this.lineChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: labels,
        datasets: [{
          label: 'S Triggers',
          backgroundColor: 'rgb(124, 111, 241, 0.2)',
          borderColor: 'rgb(124, 111, 241, 1)',
          data: sTrigger,
          borderWidth: 2,
          pointRadius: 1,
          fill: false
        }, {
          label: 'C Triggers',
          backgroundColor: 'rgb(75, 154, 248, 0.2)',
          borderColor: 'rgb(75, 154, 248, 1)',
          data: cTrigger,
          borderWidth: 2,
          pointRadius: 1,
          fill: false
        }, {
          label: 'C Triggers Cumulative',
          backgroundColor: 'rgb(0, 128, 128, 0.8)',
          borderColor: 'rgb(0, 128, 128, 0.8)',
          data: cCumulative,
          borderWidth: 2,
          pointRadius: 1,
          fill: false
        }]
      },
      options: {
        responsive: true,
        plugins: {
        legend: {
          position: 'bottom',
          display: true
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            suggestedMin: 0,
            suggestedMax: 10,
            // stepSize: highestCount > 9 ? null : 1
          },
          x: {
            ticks: {
              autoSkip: true,
              maxTicksLimit: 12
            }
          }
        },
      }
    });
  }

  downloadMonthlyBill(date) {
    const dateArray = date.split(',').map(item => item.trim());
    const months = {
      'Jan': '01',
      'Feb': '02',
      'Mar': '03',
      'Apr': '04',
      'May': '05',
      'Jun': '06',
      'Jul': '07',
      'Aug': '08',
      'Sep': '09',
      'Oct': '10',
      'Nov': '11',
      'Dec': '12'
    };
    this.reportsService.downloadMonthlyBill(months[dateArray[0]], dateArray[1]).subscribe(res => {
      const contentDisposition = res.headers.get('Content-Disposition');
      let filename;
      if (contentDisposition == null) {
        filename = 'Bill_' + date + '.zip';
      } else {
        filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
      }
      const blob = new Blob([res.body], {
        type: 'application/zip'
      });
      FileSaver.saveAs(blob, filename);
    }, error => {
      this.sharedService.getErrorMsg(error);
    });
  }

  numDifferentiation(value: number): string {
    let val: any = Math.abs(value);
    if (val >= 10000000) {
      val = (val / 10000000).toFixed(2) + ' Cr';
    } else if (val >= 100000) {
      val = (val / 100000).toFixed(2) + ' Lac';
    } else {
      val = this.addCommas(value.toFixed(2));
    }
    return val;
  }

  addCommas(value, noDecimal?): string {
    let val = value.toString();
    let afterPoint = '';
    if (val.indexOf('.') > 0) {
      afterPoint = val.substring(val.indexOf('.'), val.length);
    }
    val = Math.floor(val);
    val = val.toString();
    let lastThree = val.substring(val.length - 3);
    const otherNumbers = val.substring(0, val.length - 3);
    if (otherNumbers != '') {
      lastThree = ',' + lastThree;
    }
    const res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree + afterPoint;
    return res;
  }
}
